export default function Footer() {
  return (
    <footer className="bg-navy text-cream py-12">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <p>© {new Date().getFullYear()} Hatom Consulting. All rights reserved.</p>
      </div>
    </footer>
  )
}